<template>
<div class="content-box">
    <div ref="searchBoxRef" class="content-header">
        <div>
            <el-input class="input" v-model="queryForm.productName" placeholder="产品名称" clearable></el-input>
            <el-button @click="searchData" type="primary">搜索</el-button>
            <el-button @click="handleCreate" type="button">+ 新增</el-button>
        </div>

        <span class="store-name">
            {{storeName}}
        </span>

    </div>
    <div class="table-list">
        <ETable v-loading="loading" :max-height="tableMaxheight" :columns="columns" :data="tableData" style="width: 100%" :header-cell-style="headerCellStyle" :cell-style="cellStyle" border>
            <template #name="{row}">
                <div style="display: flex;align-items: center;">
                    <el-image :preview-src-list="[row.img]" style="flex-shrink: 0;width: 80px;height: 80px;margin-right: 5px" fit="contain" :src="row.img"></el-image>
                    {{row.name}}
                </div>
            </template>
            <template #spuName="{row}">
                <div>
                    <el-tooltip placement="top" effect="dark" :content="row.spuName" v-ak-tooltip-auto-show="{ gap: 5 }">
                        <span class="ellipsis-text-2">{{row.spuName || ""}}</span>
                    </el-tooltip>
                </div>
            </template>
            <template #status="{row}">
                <span :class="{ 'enable-btn': !row.status }">
                    {{ row.status ? "已启用" : "已禁用" }}
                </span>
            </template>
            <template #action="{row}">
                <el-button type="text" @click="update(row)">编辑</el-button>
                <el-button type="text" @click="relationProduct(row)">关联商品</el-button>
                <el-button type="text" @click="del(row)">删除</el-button>
            </template>
        </ETable>
        <el-pagination style="margin-top: 20px" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="pageSizes" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="itemTotal"></el-pagination>
    </div>

    <ChooseProductType ref="chooseProductTypeRef" @showProductDialog="showProductDialog" @refreshProductList="searchData" :chooseProductInfo="chooseProductInfo" :productId="productId"></ChooseProductType>

    <el-dialog :title="`${formData.id ? '编辑' : '新增'}产品`" :visible.sync="dialogVisible" width="460px" :before-close="dialogClose" >
        <el-form label-position="left" label-width="100px" :model="formData" ref="validateForm" label-suffix=":"
        :rules="rules">
            <el-form-item label="产品名称" prop="name">
                <el-input v-model="formData.name" class="dialogInput" placeholder="" maxlength="30">
                </el-input>
            </el-form-item>
            <el-form-item label="产品功效" prop="effect">
                <el-input v-model="formData.effect"  class="dialogInput" placeholder="" maxlength="30">
                </el-input>
            </el-form-item>
            <el-form-item label="产品头图" prop="img">
                <UploadImg :fileList.sync="formData.img" :limit="1" :size="3" />
                <p class="upload-img-tip">只支持jpg/png格式，尺寸4/3，3M以内</p>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-switch
                  :active-value="1"
                  :inactive-value="0"
                  v-model="formData.status">
                </el-switch>
            </el-form-item>
            
        </el-form>
        <div slot="footer" class="dialog-footer">
            <el-button @click="dialogClose">取消</el-button>
            <el-button type="primary" @click="dialogConfirm">提交</el-button>
        </div>
    </el-dialog>
    <MallProductList :categoryProductId="spu" :visible.sync="relatedDialogVisible" @refreshProductList="searchData"
     :getBindProductFn="getBindProductFn" :relatedProductConfirmFn="relatedProductConfirmFn" />
</div>
</template>

<script>
import {
    Mixins,
    Component, Ref
} from "vue-property-decorator";
import tablePagination from "@/mixins/tablePagination";
import ETable from "@/components/ETable.vue";
import Loading from "@/mixins/loading";
import Resize from "@/mixins/resize";

import UploadImg from "@/components/uploadImg.vue";

import { getWsStoreProductList, createWsStoreProduct, releaseStoreProduct, wsProductHasBindMallProduct, wsProductBindMallProduct } from "@/api/wsProduct";

import MallProductList from "../prescriptionProduct/components/mallProductList.vue";
import ChooseProductType from "./components/managerChooseProductType";

@Component({
    components: {
        ETable,
        UploadImg, MallProductList, ChooseProductType
    }
})
export default class WsProduct extends Mixins(Loading, tablePagination, Resize) {
    @Ref("validateForm") ValidateFormRef;
    @Ref("chooseProductTypeRef") ChooseProductTypeRef;

    tableData = [];

    queryForm = {
        productName: "",
    }
    columns = [{
            label: "产品 ID",
            prop: "id"
        },
        {
            label: "产品信息",
            prop: "name",
            minWidth: "180px"
        },
        {
            label: "产品功效",
            prop: "effect",
            minWidth: "180px"
        },
        {
            label: "数据来源",
            prop: "",
            minWidth: "100px",
            formatter: (row) => row.productSource ? "PC端" : "小程序",
        },
        {
            label: "关联商品",
            prop: "spuName",
            minWidth: "100px",
        },
        {
            label: "状态",
            prop: "status",
            minWidth: "100px",
        },
        {
            label: "操作人",
            prop: "modifiedBy",
            minWidth: "140px"
        },
        {
            label: "最后操作时间",
            prop: "modifiedTime",
            minWidth: "140px"
        },
        {
            label: "操作",
            prop: "action",
            minWidth: "140px"
        },
    ]

    storeId = this.$route.query?.storeId;
    storeName = decodeURIComponent(this.$route.query?.storeName || "");

    dialogVisible = false
    formData = {
        name: "",
        effect: "",
        img: [],
        status: 1,
    }
    rules = {
        name: { required: true, message: "请输入产品名称" },
        img: { required: true, message: "请上传产品头图" }
    }

    relatedDialogVisible = false;

    spu = "";
    productId = "";

    chooseProductInfo = {};

    relatedProduct(row) {
        this.relatedDialogVisible = true;
    }

    mounted() {
        this.windowResize();
        this.getData();
    }

    update(row) {
        const { id, name, effect, status, img } = row;
        this.dialogVisible = true;
        this.$nextTick(() => {
            Object.assign(this.formData, { id, name, effect, status, img });
        })
    }

    del(row) {
        this.$confirm("是否删除当前产品？", "提示", {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
        }).then(() => {
            const params = { id: row.id }
            releaseStoreProduct(params).then(() => {
                this.getData();
            })
        })
    }

    handleCreate() {
        this.formData.id = "";
        this.formData.status = 1;
        this.dialogVisible = true;
    }

    dialogClose() {
        this.ValidateFormRef?.resetFields();
        this.dialogVisible = false;
    }

    dialogConfirm() {
        this.ValidateFormRef?.validate().then(() => {
            const params = {
                ...this.formData,
                img: this.formData.img?.[0]?.url,
                storeId: this.storeId,
            }
            createWsStoreProduct(params).then((res) => {
                this.$message.success("操作成功");
                this.dialogClose();
                this.getData();
            })
        })
    }

    searchData() {
        this.resetCurrent();
        this.getData();
    }

    getData() {
        const params = {
            ...this.queryForm,
            pageNum: this.currentPage,
            pageSize: this.pageSize,
            id: this.storeId,
        }
        this.showLoading();
        getWsStoreProductList(params).then((res) => {
            this.tableData = res.data.list;
            this.itemTotal = res.data.total;
        }).finally(() => {
            this.hideLoading();
        })
    }

    showProductDialog() {
        this.relatedDialogVisible = true;
    }

    relationProduct(row) {
        this.spu = row.spu;
        this.productId = row.id;
        const { spu, linkUrl, spuName, appUrl } = row;
        if (linkUrl || appUrl) {
            this.ChooseProductTypeRef.linkUrl = linkUrl;
            this.ChooseProductTypeRef.appUrl = appUrl;
            this.ChooseProductTypeRef.type = "2";
        }
        if (spu) {
            this.ChooseProductTypeRef.type = "1";
            this.ChooseProductTypeRef.productName = spuName;
        }

        if (!linkUrl && !spu) {
            this.ChooseProductTypeRef.productName = "";
        }
        this.ChooseProductTypeRef.dialogVisible = true;
    }

    getBindProductFn() {
        if (!this.spu) return Promise.resolve({})
        return wsProductHasBindMallProduct({ id: this.productId }).then((res) => {
            return res.data;
        })
    }

    relatedProductConfirmFn({ name, spu }) {
        console.log(name, spu)
        this.chooseProductInfo = { name, spu };
        this.ChooseProductTypeRef.productName = name;
        this.relatedDialogVisible = false;
        // return Promise.resolve({ name, spu });
        // return wsProductBindMallProduct({ id: this.productId, spu }).then(() => {
        //     this.ChooseProductTypeRef?.dialogClose();
        // })
        // return new Promise((resolve) => {
        //     resolve({
        //         name: "测试商品名称",
        //         spu: "SPU123456"
        //     });
        // })

    }
}
</script>

<style lang="scss" scoped>
    @import "@/styles/app";

    .store-name{
        font-size: 18px;
    }
    
    .content-box {
      background: #edf0f9;
    }
    
    .content-header {
      background: #ffffff;
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      flex-wrap: wrap;
      padding: 20px;
    }
    
    .table-list {
      margin-top: 20px;
      background: #ffffff;
      border-radius: 8px;
      padding: 40px;
    }
    
    .input {
      width: 240px;
      margin-right: 12px;
      margin-bottom: 10px;
    }
    
    .button-on {
      font-size: 14px;
      font-weight: 400;
    }
    
    .status-off {
      font-size: 14px;
      font-weight: 400;
      color: #ff6700;
    }
    </style>
